// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

addToUnscopables('flatMap');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.array.unscopables.flat-map.js
// module id = 539
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33